<app-lc-header
  [newMessages]="newMessages"
  [notifications]="notifications"
  [userName]="userName"
  [userSurname]="userSurname"
  (markNotificationAsReadEvent)="markNotificationAsRead($event)">
  @if (isInRecordView && recordInfo && !isRecordStatusVisible) {
    <record-status-compact
      slot="center"
      [status]="recordStatus"
      [displayActions]="recordInfo.displayActions"
      [paymentActions]="recordPaymentActions"
      (newStatus)="onRecordStatusChange($event)"
      (newPayment)="onRecordPaymentAction($event)"
      (customAction)="onCustomAction($event)" />
  }
</app-lc-header>
